<template>
  <div>
    <template v-if="aboutLocation">
      <v-row>
        <v-col class="tcdc-map-height d-relative">
          <GmapMap
                  :center="{ lat: aboutLocation.lat, lng: aboutLocation.lon }"
                  :options="mapOptions"
                  :zoom="7"
                  style="width: 100%; height: 100%;"
          >
            <GmapMarker
                    :position="{ lat: aboutLocation.lat, lng: aboutLocation.lon }"
                    :clickable="false"
                    :draggable="false"
            />
          </GmapMap>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="vhtml" v-html="aboutLocation[`description_${lang}`]"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-tcdc-green bold sub-header2">Address</p>
          <div class="vhtml" v-html="aboutLocation[`address_${lang}`]"></div>
        </v-col>
        <v-col>
          <p class="text-tcdc-green bold sub-header2">Postal Address</p>
          <div class="vhtml" v-html="aboutLocation[`postal_address_${lang}`]"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <p class="text-tcdc-green bold sub-header2">Opening Hours</p>
          <div class="vhtml mb-3" v-html="aboutLocation[`opening_hours_detail_${lang}`]"></div>
          <v-layout justify-space-between class="vhtml" v-for="(item,i) in aboutLocation.opening_hours" :key="i">
            <v-flex shrink>
              {{item[`day_${lang}`]}}
            </v-flex>
            <v-flex shrink>
              {{item.is_open === 0 ? $t('service.locationClose'):item.time}}
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
      <v-row v-if="aboutLocation.attached_website">
        <v-col>
          <GreenButton @onPress="openLink(aboutLocation.attached_website)" :label="`visit ${aboutLocation.branch.branch_name_en}`" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import { mapState } from 'vuex';
import { mapStyles } from "../../config";
export default {
  data: () => ({
    mapOptions: mapStyles
  }),
  components: {
    GreenButton
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      aboutLocation: state => state.About.location,
    })
  },
  methods: {
    async openLink(website) {
      if (website) {
        await this.$store.dispatch('Branch/getBranchById', this.aboutLocation.branch.branch_id);
        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", {
          branch_id: this.aboutLocation.branch.branch_id,
          lang: this.lang
        });
        if (website[0] === '/') {
          this.$router.push(website);
        } else {
          this.$router.push('/' + website);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-map-height {
  height: 600px;
}
</style>
